/*
 * @Author: Michael 
 * @Date: 2018-09-18 14:57:55 
 * @Last Modified by: Michael
 * @Last Modified time: 2019-04-11 13:57:18
 */

const ua: string = navigator.userAgent.toLowerCase();

export function isWeixin(): boolean {
  const regx: RegExp = /micromessenger/i;
  return regx.test(ua);
}

export function isXiaomaiApp(): boolean {
  const AndriodRegx: RegExp = /xiaomai_android/i;
  const IOSRegx: RegExp = /xiaomai_ios/i;
  return AndriodRegx.test(ua) || IOSRegx.test(ua);
}

export function isAndroid(): boolean {
  const regx: RegExp = /android/i;
  return regx.test(ua);
}

export function isXiaoMaiIOSApp(): boolean {
  const IOSRegx: RegExp = /xiaomai_ios/i;
  return IOSRegx.test(ua);
}

export function isXiaoMaiAndroidApp(): boolean {
  const AndriodRegx: RegExp = /xiaomai_android/i;
  return AndriodRegx.test(ua);
}

export function isMobile(): boolean {
  const MobileRegx: RegExp = /Mobile/i;
  return MobileRegx.test(ua);
}